<template>
  <div>
    <p>
      Maintenance Mode
    </p>
    <SwitchFlag
      :value="maintenanceMode"
      :label-mapping="labelMapping"
      @switchFlag="manageMaintenance({
        enabled: $event,
      })" />
    <div v-if="maintenanceMode">
      <v-text-field
        v-model.trim="maintenanceMessageText"
        label="Maintenance Message"
        :hint="maintenanceMessageHint"
        class="mt-6"
        @blur="maintenanceMessageText = maintenanceMessage"
        @keyup.enter="setMaintenanceMessage({
          text: maintenanceMessageText,
        })" />
      <div
        v-if="defaultMaintenanceMessage"
        class="mt-12">
        <p class="description medium-p mb-0">
          Default Maintenance Message:
        </p>
        <p class="small-p description italic">
          <i>
            {{ defaultMaintenanceMessage }}
          </i>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapActions, mapGetters,
} from 'vuex';
import SwitchFlag from '../SiteSettingsSwitchFlag';
export default {
  name: 'SiteSettingsMaintainanceMode',
  components: {
    SwitchFlag,
  },
  data() {
    return {
      maintenanceMessageText: '',
      labelMapping: {
        on: 'Turn on maintenance mode',
        off: 'Turn off maintenance mode',
      },
    };
  },
  computed: {
    ...mapGetters({
      maintenanceMode: 'SiteConfiguration/vueAppMaintenanceMode',
    }),
    maintenanceMessage() {
      return this.getFeatureFlag('VUE_APP_MAINTENANCE_MODE_MESSAGE_CUSTOM');
    },
    defaultMaintenanceMessage() {
      return this.getFeatureFlag('VUE_APP_MAINTENANCE_MODE_MESSAGE_DEFAULT');
    },
    maintenanceMessageHint() {
      return 'Press ENTER to add new maintenance message';
    },
  },
  watch: {
    maintenanceMessage: {
      handler(val) {
        this.maintenanceMessageText = val;
      },
      immediate: true,
    },
  },
  methods: {
    ...mapActions({
      manageMaintenance: 'SiteConfiguration/manageMaintenance',
      setMaintenanceMessage: 'SiteConfiguration/setMaintenanceMessage',
    }),
    getFeatureFlag(name) {
      return this.$store.getters['SiteConfiguration/getFeatureFlagEnabling'](name);
    },
  },
};
</script>
